/**
 * Typical US secondary grade band for staff forms (6–12).
 * Reuse for any product area that uses the same credit-by-grade grid.
 */
export const SECONDARY_GRADES_6_12 = [6, 7, 8, 9, 10, 11, 12] as const;
